<avs-eva-reset [routeStationGuid]="routeStationGuid" [showReset]="detecedChanges || channelAdded"></avs-eva-reset>
<div class="d-flex justify-content-between">
    <span>Sam ID:{{samId}}</span>
    <div>
        <button mat-flat-button color="primary" class="me-2" (click)="changeOnLoggingActive()">Protokollierung</button>
        <button mat-flat-button color="primary" class="me-2" (click)="changeOnSurveillance()">Überwachung</button>
    </div>
</div>
<div class="row">
    <div class="col-2 text-secondary pb-2 border-bottom border-danger">Aktionen</div>
    <div class="col-3 text-secondary pb-2 border-bottom border-danger">Typ</div>
    <div class="col-2 text-secondary pb-2 border-bottom border-danger">Status</div>
    <div class="col-5 row">
        <div class="col-2 text-secondary pb-2 border-bottom border-danger">DE-Kanal</div>
        <div class="col-3 text-secondary pb-2 border-bottom border-danger">Localbus Adresse</div>
        <div class="col-3 text-secondary pb-2 border-bottom border-danger">Eakanal</div>
        <div class="col-4 text-secondary pb-2 border-bottom border-danger">Überwachung</div>
    </div>
</div>

<div class="row" *ngFor="let dataEndChannel of dataEndChannels">
    <div class="col-2 border-bottom">
        <div class="d-flex">
            <img class="avs-icon-edit mt-2 mb-1 p-1" src="assets/icons/pencil.svg" alt="icon-edit dataEndChannel"
                (click)="onEditBtnClicked(dataEndChannel)">
            <img class="avs-icon-delete mt-2 mb-1 p-1" src="assets/icons/trash.svg" alt="icon-delete dataEndChannel"
                (click)="onDeleteBtnClicked(dataEndChannel)">
            <img *ngIf="dataEndChannel.timerId" class="avs-icon-delete mt-2 mb-1 p-1" src="assets/icons/stopwatch.svg"
                alt="remove timer assignment" (click)="onRemoveTimerAssignment(dataEndChannel.id)"
                matTooltip="Kanal ID: {{dataEndChannel.id}}">
            <img *ngIf="dataEndChannel.fG01_Settings!.length > 2 || dataEndChannel.fG04_Settings.length > 2  && !isItCluster(dataEndChannel)"
                class="avs-icon-delete mt-2 mb-1 p-1" src="assets/icons/gear.svg" alt="icon-delete dataEndChannel"
                (click)="showFGSettings(dataEndChannel)">
            <img *ngIf="dataEndChannel.fG06_Settings.length > 2 && isItDO(dataEndChannel)"
                class="avs-icon-delete mt-2 mb-1 p-1 " src="assets/icons/gear.svg" alt="icon-delete dataEndChannel"
                (click)="showFGSettings(dataEndChannel)">
            <img *ngIf="isItDI(dataEndChannel)"
                class="avs-icon-delete mt-2 mb-1 p-1 " src="assets/icons/gear.svg" alt="icon-delete dataEndChannel"
                (click)="showDigitalInputSettings(dataEndChannel)">
            <img *ngIf="isItLED(dataEndChannel)"
                class="avs-icon-delete mt-2 mb-1 p-1" src="assets/icons/file-image-fill.svg"
                alt="icon-delete dataEndChannel" (click)="createFallbackSettings(dataEndChannel)">
            <img *ngIf="isItLED(dataEndChannel)"
                class="avs-icon-delete mt-2 mb-1 p-1" src="assets/icons/broken_image.svg"
                alt="icon-delete dataEndChannel" (click)="checkPixelerror(dataEndChannel)">
            <img *ngIf="isItAdec(dataEndChannel)" class="avs-icon-delete mt-2 "
                src="assets/icons/data-end-channel/radar.svg" alt="icon-delete dataEndChannel"
                style="width: 30px; height: 30px;" (click)="editSensorSettings(dataEndChannel)">
            <img *ngIf="isItBlinker(dataEndChannel)"
                class="avs-icon-delete mt-2 mb-1 p-1" src="assets/icons/lightbulb.svg" alt="icon-delete dataEndChannel"
                (click)="createFallbackFlasherSettings(dataEndChannel)">
        </div>
    </div>
    <div class="col-3 border-bottom">
        <div class="d-flex">
            <img class="avs-data-end-channel-type-icon me-2 mt-2" [src]="getDataEndChannelTypeIcon(dataEndChannel.dataEndChannelType)"
                alt="DataEndChannel Type Icon"
                [class.avs-data-end-channel-type-icon-clickable]="deviceInfoByChannelId.has(dataEndChannel.id)"
                [matTooltip]="deviceInfoByChannelId.has(dataEndChannel.id) ? 'Geräteinformationen anzeigen' : 'Keine Geräteinformationen vorhanden'"
                (click)="showDeviceInfo(dataEndChannel)">
            <div class="mt-1 mb-1">
                <div>{{getDataEndChannelTypeString(dataEndChannel.dataEndChannelType)}}</div>
                <div class="text-secondary small">fg: {{dataEndChannel.fg}}</div>
            </div>
        </div>
    </div>
    <div class="col-2 border-bottom">
        <div class="mt-2 mb-2">
            <span
                [class]="getChannelStateClassString(dataEndChannel) + ' p-1'">{{getChannelErrorString(dataEndChannel)}}</span>
        </div>
    </div>
    <div class="col-5 row">
        <div class="col-2 border-bottom">
            <div class="mt-2">{{dataEndChannel.de}}</div>
        </div>
        <div class="col-3 border-bottom">
            <div class="mt-2">{{dataEndChannel.localbusAddress}} - {{ whichRadarType(dataEndChannel) ?
                whichRadarType(dataEndChannel) : getLocalBusTypeString(dataEndChannel.localbusAddress) }}</div>
        </div>
        <div class="col-3 border-bottom">
            <div class="mt-2">{{dataEndChannel.eakanalnr}}</div>
        </div>
        <div class="col-4 border-bottom">
            <div class="d-flex">
                <mat-slide-toggle class="example-margin" [checked]="dataEndChannel.loggingActive"
                    (change)="onLoggingActiveChange(dataEndChannel)"
                    [matTooltip]="dataEndChannel.loggingActive ? 'Protokollierung deaktivieren' : 'Protokollierung aktivieren'">
                </mat-slide-toggle>
                <mat-slide-toggle class="example-margin" [checked]="dataEndChannel.surveillanceActive"
                    (change)="onSurveillanceActiveChange(dataEndChannel)"
                    [matTooltip]="dataEndChannel.surveillanceActive ? 'Überwachung deaktivieren' : 'Überwachung aktivieren'">
                </mat-slide-toggle>
                <img *ngIf="dataEndChannel.errorThresholds.length > 0" class="avs-icon-delete mt-2 mb-1 p-1"
                    src="assets/icons/contract_delete.svg" alt="icon-delete dataEndChannel"
                    (click)="onDeleteTresholds(dataEndChannel)" matTooltip="Schwellenwerte löschen">
                <img class="avs-icon-create mt-2 mb-1 p-1" src="assets/icons/contract.svg"
                    alt="icon-delete dataEndChannel" (click)="onCreateOrEditTreshold(dataEndChannel)"
                    matTooltip="Schwellenwerte bearbeiten">
            </div>
        </div>
    </div>
</div>
